<template>
  <b-card>
    <FormBuilder
      label="Layanan Kurir"
      update
      :data="$store.state.courierService.detailData"
      :fields="fields"
      :loading-detail="$store.state.courierService.loadingDetail"
      :loading-submit="$store.state.courierService.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/courier-service'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('courierService/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('courierService/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('courierService/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
